import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { Employee } from '@qaroni-app/employee/types/employee';
import { EmployeeAddress } from '@qaroni-app/employee/types/employee-address';
import { EmployeeApiObject } from '@qaroni-app/employee/types/employee-response';
import { EmployeeDisabilityApiObject } from '@qaroni-app/employee/types/employee-disability-response';
import { EmployeeHistoryApiObject } from '@qaroni-app/employee/types/employee-history-response';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';

@Injectable({
  providedIn: 'root',
})
export class PanelProfileHttpService {
  private http = inject(HttpClient);

  public getEmployee$(employeeId: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeId}`;

    return this.http.get<EmployeeApiObject>(url, { observe: 'response' });
  }

  public updateProfile$(employeeId: number, employee: Employee) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeId}`;

    return this.http.patch<EmployeeApiObject>(url, employee, {
      observe: 'response',
    });
  }

  public updateEmployeeAddress$(
    employeeId: number,
    employeeAddress: EmployeeAddress
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeId}/addresses`;

    return this.http.patch<EmployeeApiObject>(url, employeeAddress, {
      observe: 'response',
    });
  }

  public getEmployeeDisabilities$(employeeId: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeId}/disabilities`;

    return this.http.get<EmployeeDisabilityApiObject>(url, {
      observe: 'response',
      params,
    });
  }

  public getEmployeeHistories$(employeeId: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/employees/${employeeId}/histories`;

    return this.http.get<EmployeeHistoryApiObject>(url, {
      observe: 'response',
      params,
    });
  }
}
